'use client';

import { type ReactNode, useEffect } from 'react';

import { OVERLAY_STORAGE_ITEM_NAME, OVERLAY_STORAGE_ITEM_VALUE } from '@/shared/components/header/stores/header-store';
import { useHeaderStore } from '@/shared/components/header/stores/header-store-provider';
import { Dialog, DialogContent, DialogTitle } from '@/shared/ui/dialog';

export type SiteOverlayWrapperProps = {
    btnLabel: string;
    children: ReactNode;
};

export const SiteOverlayWrapper = ({ children, btnLabel }: SiteOverlayWrapperProps) => {
    const { overlayNotice, toggleOverlayNotice, setOverlayNotice } = useHeaderStore(state => state);

    useEffect(() => {
        setOverlayNotice({ btnLabel });

        setTimeout(() => {
            if (window.localStorage.getItem(OVERLAY_STORAGE_ITEM_NAME) !== OVERLAY_STORAGE_ITEM_VALUE) {
                toggleOverlayNotice();
            }
        }, 5000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onInteractOutside: Parameters<typeof DialogContent>[0]['onInteractOutside'] = event => {
        const cookiebotDialogEl = document.getElementById('CybotCookiebotDialog');
        if (
            cookiebotDialogEl &&
            (event.target === cookiebotDialogEl || cookiebotDialogEl.contains(event.target as Node))
        ) {
            event.preventDefault();
        }
    };

    return (
        <Dialog open={overlayNotice.open} onOpenChange={toggleOverlayNotice}>
            <DialogContent
                className='bg-surface-light block min-h-125 w-[calc(100dvw-2rem)] p-0 lg:max-w-[calc(80rem-2rem)] lg:overflow-hidden'
                onInteractOutside={onInteractOutside}>
                <DialogTitle className='sr-only'>{btnLabel}</DialogTitle>
                {children}
            </DialogContent>
        </Dialog>
    );
};
